import React, {useEffect, useState} from 'react';
import TableGrid from "../../../components/Table/TableGrid";
import {apiGet, apiPost} from "../../../services/apiClient";
import {Form, Grid as GridView, Input} from "semantic-ui-react";
import ButtonCargo from "../form_v3/buttons/buttonCargo";
import ButtonDocs from "../form_v3/buttons/buttonDocs";
import Dropdown from "../../../components/Dropdown";
import RangeDatePicker from "../../../components/DatePicker/RangeDatePicker";
import StateDropdown from "../../../components/Dropdowns/StateDropdown";
import InputDropdown from "../../../components/Dropdowns/InputDropdown";
import {dateToFilterFormat} from "../../../services/date";

const FiltersBlock = ({filters, updateFilter, clearSettings, isBusy}) => {
    const [statuses, setStatuses] = useState([]);
    const [carriers, setCarriers] = useState([]);

    const getStatuses = () => apiGet('parcels/status/all')
        .then(data => {
            setStatuses((data.entries || []).map(s => ({
                key: s.id,
                value: s.id,
                text: s.name,
                code: s.code
            })))
        })
        .catch(e => console.log(e));

    const getCarriers = () => apiPost('parcels/list/author/ref/carriers', {})
        .then(data => {
            setCarriers((data.entries || []).map(s => ({
                key: s.id,
                value: s.id,
                text: s.name,
            })))
        })
        .catch(e => console.log(e));

    useEffect(() => {
        getStatuses();
        getCarriers();
    }, []);

    const setTypeFilter = (name, type) => {
        let filter = filters[name] || [];
        filter.includes(type) ? filter = filter.filter(f => f !== type) : filter.push(type);
        updateFilter(name, filter)
    }

    return <section className='filters-block sizes-block'>
        <GridView>
            <GridView.Row>
                <GridView.Column>
                    <Form.Field>
                        <label>
                            Тип отправления
                        </label>
                        <div className='types-btns'>
                            <ButtonCargo
                                isSelected={(filters.parcelType || []).includes('2')}
                                onClick={() => setTypeFilter('parcelType', '2')}
                            />
                            <ButtonDocs
                                isSelected={(filters.parcelType || []).includes('1')}
                                onClick={() => setTypeFilter('parcelType', '1')}
                            />
                        </div>
                    </Form.Field>
                </GridView.Column>
                <GridView.Column>
                    <GridView>
                        <GridView.Row columns={16}>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input ultra-compact'>
                                    <label>
                                        Город и адрес отправки
                                    </label>
                                    <InputDropdown
                                        placeholder={'Введите город или адрес отправки'}
                                        name={'fullName'}
                                        url={'parcels/addresses/suggestions'}
                                        value={filters.shipmentAddress || ''}
                                        onChange={(name, value) => {
                                            updateFilter('shipmentAddress', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Отправитель
                                    </label>
                                    <Input
                                        placeholder={'Введите юр. название или контактное лицо'}
                                        fluid
                                        value={filters.senderFullName || ''}
                                        onChange={(e, {value}) => {
                                            updateFilter('senderFullName', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Перевозчик
                                    </label>
                                    <Dropdown
                                        search={false}
                                        multiple
                                        compact
                                        options={carriers}
                                        value={filters.carrier || []}
                                        onChange={(e, {value}) => updateFilter('carrier', value)}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}/>
                        </GridView.Row>
                    </GridView>
                </GridView.Column>
            </GridView.Row>
            <GridView.Row>
                <GridView.Column>
                    <Form.Field>
                        <div className='types-btns'>
                            <Form.Field className='filter-input'>
                                <RangeDatePicker
                                    compact
                                    label={"Даты отгрузки"}
                                    dateFromName="from"
                                    dateFromValue={filters.departureDateFrom}
                                    dateToName="to"
                                    dateToValue={filters.departureDateTo}
                                    onChange={(d) => {
                                        updateFilter('departureDateFrom', d.from);
                                        updateFilter('departureDateTo', d.to);
                                    }}
                                    pattern='dd.MM.yyyy'
                                />
                            </Form.Field>
                            <Form.Field className='filter-input'>
                                <RangeDatePicker
                                    compact
                                    label={"Даты доставки"}
                                    dateFromName="from"
                                    dateFromValue={filters.deliveryDateFrom}
                                    dateToName="to"
                                    dateToValue={filters.deliveryDateTo}
                                    onChange={(d) => {
                                        updateFilter('deliveryDateFrom', d.from);
                                        updateFilter('deliveryDateTo', d.to);
                                    }}
                                    pattern='dd.MM.yyyy'
                                />
                            </Form.Field>
                        </div>
                    </Form.Field>
                </GridView.Column>
                <GridView.Column>
                    <GridView>
                        <GridView.Row columns={16}>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input ultra-compact'>
                                    <label>
                                        Город и адрес доставки
                                    </label>
                                    <InputDropdown
                                        placeholder={'Введите город или адрес доставки'}
                                        name={'fullName'}
                                        url={'parcels/addresses/suggestions'}
                                        value={filters.deliveryAddress || ''}
                                        onChange={(name, value) => {
                                            updateFilter('deliveryAddress', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Получатель
                                    </label>
                                    <Input
                                        placeholder={'Введите юр. название или контактное лицо'}
                                        fluid
                                        value={filters.recipientFullName || ''}
                                        onChange={(e, {value}) => {
                                            updateFilter('recipientFullName', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Статус перевозки
                                    </label>
                                    <StateDropdown
                                        compact
                                        options={statuses}
                                        value={filters.status || []}
                                        onChange={(e, {value}) => updateFilter('status', value)}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column className={'filters-btn'} width={3} textAlign='center'>
                                <div
                                    onClick={() => !isBusy && clearSettings()}
                                    className='total__change-btn_name'
                                >
                                    Сбросить фильтры
                                </div>
                            </GridView.Column>

                        </GridView.Row>
                    </GridView>
                </GridView.Column>
            </GridView.Row>
        </GridView>
    </section>
}

const FiltersAndTable = ({disableFilters, isBusy, onFiltersChange, loadData, gridKey, columns, selectedIds, setAll, setSelected, searchId, setSearchId, setSettings, filtersWidth, isFixed}) => {
    const rowCount = 50;
    const [filters, setFilters] = useState({});
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const dateFilter = (name, filtersArray) => {
        const date = dateToFilterFormat(filters[name]);
        const from = dateToFilterFormat(filters[`${name}From`]);
        const to = dateToFilterFormat(filters[`${name}To`]);

        let operation;
        if (date) operation = 'equals'
        else {
            if (from && to) operation = 'between'
            else if (from) operation = 'greater-equal'
            else operation = 'less-equal'
        }

        (date || from || to) && filtersArray.push({
            fieldName: name,
            operation,
            value: (date || [from, to]).toString()
        })
    }

    const getSettings = () => {
        let filtersArray = [];
        Object.keys(filters).forEach(fName => {
            !fName.includes('Date') && filters[fName] && filters[fName].length !== 0 && filtersArray.push({
                fieldName: fName,
                operation: Array.isArray(filters[fName]) ? 'in' : 'contains',
                value: filters[fName].toString()
            })
        });

        searchId && filtersArray.push({
            fieldName: 'anyNumber',
            operation: 'contains',
            value: searchId
        })

        dateFilter('deliveryDate', filtersArray);
        dateFilter('departureDate', filtersArray);

        return {
            filters: filtersArray.length ? filtersArray : null,
            order
        };
    }

    const loadPage = () => {
        setLoading(true);
        let settings = getSettings();
        loadData(settings, rowCount, (page - 1) * rowCount)
            .then(rows => {
                setRows(rows.entries);
                setTotalCount(rows.totalCount)
                setLoading(false);
            });
    }

    const applySettings = () => {
        let settings = getSettings();
        apiPost('grid/settings/' + gridKey, settings);
    }

    useEffect(() => {
        onFiltersChange && onFiltersChange();
        setPage(1);
    }, [filters]);

    useEffect(() => {
        applySettings();
    }, []);

    useEffect(() => {
        loadPage();
    }, [filters, searchId, page, order]);

    const updateFilter = (fieldName, filterValue) => {
        setFilters(filters => {
            filters = {
                ...filters,
                [fieldName]: filterValue
            };
            return filters;
        })
    }

    const updateSort = (fieldName) => {
        const oldOrder = (order || {}).fieldName === fieldName ? order.order : null;
        setOrder(oldOrder === 'desc' ? null : {
                fieldName,
                order: !oldOrder ? 'asc' : 'desc'
            })
    }

    const clearSettings = () => {
        setFilters({});
        setSearchId('');
    }

    useEffect(() => setSettings(getSettings()), [order, filters]);

    return (<div style={{marginTop: filtersWidth && '82px'}}>
        <FiltersBlock
            filters={filters}
            updateFilter={updateFilter}
            clearSettings={clearSettings}
            isBusy={isBusy}
        />
        <section className='table-block'>
            <TableGrid
                width={isFixed && filtersWidth}
                selectedIds={selectedIds}
                setAll={setAll}
                setSelected={setSelected}
                totalCount={totalCount}
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                columns={columns}
                checkbox={false}
                disableFilters={disableFilters}
                updateFilter={updateFilter}
                filters={filters}
                rows={rows}
                filtersParams={{
                    deliveryDate: {
                        from: filters.deliveryDateFrom,
                        to: filters.deliveryDateTo
                    },
                    departureDate: {
                        from: filters.departureDateFrom,
                        to: filters.departureDateTo
                    }
                }}
                setSort={updateSort}
                sort={order}
                loading={loading}
            />
        </section>
    </div>);
};

export default FiltersAndTable;


// WEBPACK FOOTER //
// ./App/pages/parcels/table/filtersAndTable.jsx